import { render, staticRenderFns } from "./ExpressAttraction.vue?vue&type=template&id=23c80c99&scoped=true"
import script from "./ExpressAttraction.vue?vue&type=script&lang=js"
export * from "./ExpressAttraction.vue?vue&type=script&lang=js"
import style0 from "./ExpressAttraction.vue?vue&type=style&index=0&id=23c80c99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c80c99",
  null
  
)

export default component.exports